import { RatingDisplay as FluentRatingDisplay } from "@fluentui/web-components";
/**
 * RatingDisplay
 * @summary A Rating Display Custom HTML Element. Based on FluentRatingDisplay and includes style and layout specific attributes.
 *
 * @example
 * ```html
 * <fabric-rating-display color="marigold" size="large" compact>
 *   <svg slot="icon" viewBox="0 0 20 20"><use href="#star"></use></svg>
 *   <span slot="value">4.5</span>
 *   <span slot="count">(10)</span>
 * </fabric-rating-display>
 * ```
 *
 * @attr {RatingDisplayColor | undefined} color - The color of the rating display icons. Default: `marigold`
 * @attr {RatingDisplaySize | undefined} size - The size of the component. Default: 'medium'
 * @attr {boolean | undefined} compact - Renders a single filled icon with a label next to it. Default: false
 *
 * @prop {boolean} compact - Renders a single filled icon with a label next to it. Default: false
 *
 * @slot icon - SVG element used as the rating icon. Default: star symbol.
 * @slot value - Displays the value of the rating.
 * @slot count - Displays the number of ratings.
 *
 * @cssprop --_attr-max - Internal max value derived from the max attribute.
 * @cssprop --_attr-value - Internal value derived from the value attribute.
 * @cssprop --_default-max - Default max fallback used when no attribute is set.
 * @cssprop --_default-value - Default value fallback used when no attribute is set.
 * @cssprop --_icon-color-empty - Color for empty (unfilled) icons.
 * @cssprop --_icon-color-value - Color for the filled icon portion.
 * @cssprop --_icon-gradient-degree - Gradient angle used for partial fill rendering.
 * @cssprop --_icon-gradient-stop - Primary gradient stop for partial fill.
 * @cssprop --_icon-gradient-stop-visual-adjustment - Adjustment applied to the gradient stop to align visuals.
 * @cssprop --_icon-size - Computed icon size used for layout.
 * @cssprop --_mask-image-filled - Mask image for the filled icon state.
 * @cssprop --_mask-image-outlined - Mask image for the outlined icon state.
 * @cssprop --_mask-inline-size - Inline size of the mask image.
 * @cssprop --_mask-position-x - Horizontal mask position used for partial fill.
 * @cssprop --_max - Computed max value used in layout calculations.
 * @cssprop --_value - Computed current value used in layout calculations.
 *
 * @extends FluentRatingDisplay
 * @tagname fabric-rating-display
 * @public
 */
export class RatingDisplay extends FluentRatingDisplay {
}
//# sourceMappingURL=rating-display.js.map